import React, {Component, Fragment} from 'react';

import './UserDetails.css';

import {FormLabeledItem} from '../../components/FormUI';
import User from '../../api/User';
import moment from 'moment';
import ActionButton from '../../components/ActionButton';
import PatientService from '../../api/services/PatientService';
import {UserDetail} from '../../api/services/UserService';
import {AssessmentReportSideBar} from '../Assessment/AssessmentReport';
import {ActionModal, SideModal} from '../../components/BioPedModal';
import FollowUpService from '../../api/services/FollowUpService';
import {saveAs} from "file-saver";
import AddressFormat from 'address-format';
import UserForm from "./forms/UserForm";
import DocumentService from "../../api/services/DocumentService";
import UITree, {UITreeItem} from "../../components/tree/UITree";
import {LoadingSpinner} from "../../components/BiopedUI";
import {Icon} from "semantic-ui-react";
import {isArray} from "lodash";


/**
 * Formats the address object into a standardized format.
 *
 * @param {Object} address - The address object to be formatted.
 * @param {string} address.address1 - The first line of the address.
 * @param {string} [address.address2] - The second line of the address (optional).
 * @param {string} [address.address3] - The third line of the address (optional).
 * @param {string} address.city - The city of the address.
 * @param {string} address.province - The subdivision or province of the address.
 * @param {string} address.postalCode - The postal code of the address.
 * @param {string} [address.countryCode] - The country code of the address (optional).
 *
 * @return {string} The formatted address.
 */
function formatAddress(address) {
	let props = {
		address: 'address1',
		address2: 'address2',
		address3: 'address3',
		city: 'city',
		subdivision: 'province',
		postalCode: 'postalCode',
		countryCode: 'countryCode'
	};

	let o = {countryCode: 'US'};

	for (let p in props) {
		let ap = props[p];
		if (address[ap]) {
			o[p] = address[ap];
		}
	}

	if (o.address2) {
		o.address2 = "Unit " + o.address2;
	}

	return AddressFormat(o);
}

export default class UserDetails extends Component {
	state = {};

	constructor(props) {
		super(props);
		//this.state.user = this.parseUser(props.user);

		this.handleBack = this.handleBack.bind(this);
		this.handleEdit = this.handleEdit.bind(this);
	}

	/* componentDidMount(){
		 if(this.props.clientId || this.props.user.clientId){
			 this.loadPatient(this.props.clientId || this.props.user.clientId);
		 }
	 }

	 loadPatient(id){
		 PatientService.GetById(id).then((user)=>{
			 console.log("User Details Loaded:", user)
			 this.setState({user:user});
		 })
	 }*/

	parseUser(user) {
		return new User(user);
		/*let u =  {};
		for(let p in user){
			u[p] = (user[p])? user[p]:<span>- -</span>;
		}*/
	}

	/*componentWillReceiveProps(props){
		if(props.user && (props.user.clientId != this.props.user.clientId)){
			let service = new PatientService();
			service.getById(props.user.clientId).then((user) => {

				this.setState({user:this.parseUser(user)});
			})
		}
	}*/

	handleEdit() {
		if (this.props.onEdit) {
			this.props.onEdit(this.state.user || this.props.user);
		} else {
			this.setState({showEdit: true})
		}

	}

	handleBack() {
		if (this.props.onBack) {
			this.props.onBack();
		}
	}

	handleDetailsLoaded = (details) => {
		this.setState({user: details});
	}

	render() {
		let details = this.state.user || this.props.user || {};
		let backCaption = this.props.backCaption || 'Back to Client Search';
		let Card = this.props.detailCard || DetailCard;
		//let isBusy = !this.state.user;
		return (
			<div className='user-details'>
				{(this.props.onBack) ? <span className='back' onClick={this.handleBack}>{backCaption}</span> : null}
				<div className='detail-content'>
					{(this.props.onEdit && !this.props.hideEdit) ? <ActionButton onClick={this.handleEdit}/> : null}
					<Card user={details} onDetails={this.handleDetailsLoaded}/>
				</div>
				<ActionModal close='Close' title='Edit Patient' className='scrollable' isOpen={this.state.showEdit}
				             onRequestClose={() => this.setState({showEdit: false})}>
					<UserForm className='popup-form' user={details} onBack={() => this.setState({showEdit: false})}/>
				</ActionModal>
			</div>
		)
	}
}

export class DetailCard extends Component {
	state = {};


	componentDidMount() {
		if (this.props.clientId || this.props.user.clientId) {
			this.loadPatient(this.props.clientId || this.props.user.clientId);
		}
	}

	loadPatient(id) {
		PatientService.GetById(id).then((user) => {
			console.log("User Details Loaded:", user)
			this.setState({user: user});
			if (this.props.onDetails) {
				this.props.onDetails(user);
			}
		})
	}

	showAssessment = (id, version) => {
		this.setState({showAssessment: true, assessmentId: id, version: version});
	}

	render() {

		let isBusy = !this.state.user;


		let details = this.state.user || {};
		let assessments = [];
		const years = {};
		if (details.assessments) {
			const sortedAss = details.assessments.sort((a, b) => {
				const d1 = moment(a.modified);
				const d2 = moment(b.modified);
				if(d1 < d2)return -1;
				if(d1 > d2)return 1;
				return 0;
			})
			for (let i = sortedAss.length - 1; i >= 0; i--) {
				let ass = sortedAss[i];
				const year =  moment(ass.modified).format('YYYY');
				let date = moment(ass.modified).format('MMMM D, YYYY');
				if(!years[year]){
					years[year] = [];
					assessments.push(<UITreeItem title={year}>{years[year]}</UITreeItem>)
				}
				years[year].push(<div className='assessment-btn' onClick={() => this.showAssessment(ass.assessmentId, ass.version)}>{date}</div>)
			}
		}


		let address = formatAddress(details).map((v) => {
			return <div>{v}</div>;
		});


		console.log("Formated Address:", address);

		return (
			<Fragment>

				<div className='user-detail-card table hmax align-top layout-fixed'>
					<div>
						<div>
							<h1>{details.fullName}</h1>
							<FormLabeledItem label='Address'>
								{address}
							</FormLabeledItem>
							<FormLabeledItem label='Contact Info' parentItem>
								<div className='table hmax layout-fixed'>
									<div>
										<div>
											<FormLabeledItem label='Home Phone'>
												{details.homePhone}
											</FormLabeledItem>
										</div>
										<div>
											<FormLabeledItem label='Work Phone'>
												{details.workPhone}
											</FormLabeledItem>
										</div>
										<div>
											<FormLabeledItem label='Cell Phone'>
												{details.cellPhone}
											</FormLabeledItem>
										</div>
									</div>
								</div>
								<div>
									<div className='table hmax align-middle'>
										<div>
											<div><span className='email-header'>Email:</span></div>
											<div className='align-center hmax'><span>{details.email}</span></div>
										</div>
									</div>

								</div>
							</FormLabeledItem>
							<FormLabeledItem label='Personal Information'>
								<pre>{details.personalInformation}</pre>
							</FormLabeledItem>
							<FormLabeledItem label='Allergies'>
								<pre>{details.allergies}</pre>
							</FormLabeledItem>
						</div>
						<div>
							<div className='table hmax align-top layout-fixed'>
								<div>
									<div>
										<FormLabeledItem label='Gender'>
											{details.gender}
										</FormLabeledItem>
										<FormLabeledItem label='Other Info' parentItem>
											<FormLabeledItem label='Shoe Size'>
												{details.shoeSize}
											</FormLabeledItem>
											<FormLabeledItem label='Insurance'>
												{details.insurance}
											</FormLabeledItem>
											<FormLabeledItem label='Referring Professional'>
												<UserDetail clientId={details.referringProfessional} detail='fullName'/>
											</FormLabeledItem>
											<FormLabeledItem label='Pref. Contact Method'>
												{details.preferredContactMethod}
											</FormLabeledItem>
											<FormLabeledItem label='How you heard of us'>
												{details.howHeard}
											</FormLabeledItem>
											<FormLabeledItem label='Assessments'>
												{assessments}
											</FormLabeledItem>
										</FormLabeledItem>
									</div>
									<div>
										<FormLabeledItem label='DOB'>
											{(details.birthDate) ? moment(details.birthDate).format('MMMM D, YYYY') : null}
										</FormLabeledItem>
										<FormLabeledItem label={<span>&nbsp;</span>} parentItem>
											<FormLabeledItem label='Employer'>
												{details.employer}
											</FormLabeledItem>
											<FormLabeledItem label='Guardian'>
												{details.guardian}
											</FormLabeledItem>
											<FormLabeledItem label='Family Physician'>
												{details.familyPhysician}
											</FormLabeledItem>
											<FormLabeledItem label='Pref. Contact Time'>
												{details.preferredContactTime}
											</FormLabeledItem>
											<FormLabeledItem label='# of Weight Bearing Hours'>
												{details.weightBearingHours}
											</FormLabeledItem>
											<FormLabeledItem label='Documents'>
												{/*details.assessments*/}
												<UITreeItem title={<b>Legacy Documents</b>}>
													<UserDocumentsList user={this.state.user}/>
												</UITreeItem>

												<DocumentList user={this.state.user}/>
											</FormLabeledItem>
										</FormLabeledItem>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<AssessmentReportSideBar isOpen={this.state.showAssessment} version={this.state.version} id={this.state.assessmentId} user={this.props.user}
				                         onRequestClose={() => this.setState({showAssessment: false})}/>
			</Fragment>
		)
	}
}

export class UserDocumentsList extends Component {
	state = { loaded: false };
	titles = {'biomechanicalassessment': 'BioMech Eval', 'clinic': 'Clinic / Insurance', 'patientemail': 'Email'}

	componentDidMount() {
		this.update();
	}

	componentDidUpdate(prevProps) {
		let prevUser = prevProps.user || {};
		let user = this.props.user || {};
		// console.log('componentDidUpdate: prevUserId = ', prevUser, '  Current UserId = ', this.props.user);
		if (prevUser.clientId != user.clientId) {
			this.update();
		}
	}

	update() {
		// console.log('UserDocuments Update')
		if (this.props.user) {
			FollowUpService.GetUserFollowUps(this.props.user.clientId).then((followups) => {
				// console.log('FollowUps:', followups);
				this.setState({followups: followups, loaded: true});
			});
		}
	}

	handleLinkClick = (req, docProps) => {
		console.log('Doc Link:', req);
		if (this.state.isDownloading == req.clientFollowupId) return;

		this.setState({isDownloading: req.clientFollowupId});
		FollowUpService.GetDocument(docProps).then((doc) => {
			console.log('Doc:', doc)
			let filename = req.followupType + '-' + moment().format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS) + '.doc';
			saveAs(doc, filename);
			this.setState({isDownloading: false});
		})
	}


	render() {
		let items = [];

		if (this.state.followups) {
			let fu = this.state.followups;
			let docType = {'biomechanicalassessment': 'Letter', 'clinic': 'Letter'};
			for (let i = 0; i < fu.length; i++) {
				let req = fu[i];
				let isDl = (this.state.isDownloading == req.clientFollowupId);
				let title = [this.titles[req.followupType]];
				if (isDl) {
					title.unshift(<span className="Select-loading"></span>);
				}

				let docProps = {
					FollowupId: req.clientFollowupId,
					DocumentCategory: docType[req.followupType]
				}


				items.push(<div className='doc-link' onClick={() => this.handleLinkClick(req, docProps)}><Icon name="file"/>{title}</div>);
			}
			let tpdoc = {
				"AssesmentId": fu[0].assessmentId,
				"DocumentCategory": "TreatmentPlan"
			}
			items.push(<div className='doc-link' onClick={() => this.handleLinkClick({
				followupType: 'treatmentplan',
				clientFollowupId: fu[0].clientFollowupId
			}, tpdoc)}><Icon name="file"/>Treatment Plan</div>)
		} else if(!this.state.loaded) {
			items = <LoadingSpinner />
		}

		if(!items.length && this.state.loaded) {
			items = '- No Documents Found -';
		}

		return (
			<div className='user-doc-list'>
				{items}
			</div>
		)
	}
}

/*
export class UserDetailPopup extends Component{
    state = {};
    handleEdit = () =>{
        this.setState({showEdit:true, showDetails:false});
    }
    render(){
        return(
            <Fragment>
                <BiopedModal isOpen={this.state.showDetails} onRequestClose={() => this.setState({showDetails:false})}>
                    <UserDetails hideEdit={this.props.hideEdit} user={this.props.user} backCaption='Close' onBack={() => this.setState({showDetails:false})} onEdit={this.handleEdit} />
                </BiopedModal>
                <ActionModal close='Close' title='Edit Patient' className='scrollable' isOpen={this.state.showEdit} onRequestClose={() => this.setState({showEdit:false})}>
                    <UserForm className='popup-form' user={this.props.user} onBack={() => this.setState({showEdit:false})} />
                </ActionModal>
            </Fragment>
        )
    }
}*/

const DOC_TYPE_ASSESSMENT = 'assessment';
const DOC_TYPE_CLIENT_DOCUMENT = 'clientDocument';
const DOC_TYPE_FOLLOWUP = 'followup';

class UserDoc {
	constructor(doc) {
		this.doc = doc;
	}

	/**
	 *
	 * @returns {string}
	 */
	type() {
		const doc = this.doc;
		if (Object.hasOwn(doc, 'assessmentId')) {
			return DOC_TYPE_ASSESSMENT;
		}
		if (Object.hasOwn(doc, 'clientDocumentId')) {
			return DOC_TYPE_CLIENT_DOCUMENT;
		}
		if (Object.hasOwn(doc, 'clientFollowupId')) {
			return DOC_TYPE_FOLLOWUP;
		}
	}

	title() {
		const type = this.type();
		if (type) {
			switch (type) {
				case DOC_TYPE_CLIENT_DOCUMENT:
					return moment(this.doc.modifiedDate);
					break;
				case DOC_TYPE_ASSESSMENT:
					return this.getDate().format('MMMM D, YYYY');
					break;
				case DOC_TYPE_FOLLOWUP:
					return this.getDate().format('MMMM D, YYYY');
					break;
			}
		}
	}

	/**
	 *
	 * @returns {moment.Moment}
	 */
	getDate() {
		const type = this.type();
		if (type) {
			switch (type) {
				case DOC_TYPE_CLIENT_DOCUMENT:
					return moment(this.doc.modifiedDate);
					break;
				case DOC_TYPE_ASSESSMENT:
					return moment(this.doc.modified);
					break;
				case DOC_TYPE_FOLLOWUP:
					return moment(this.doc.created);
					break;
			}
		}
	}

	isValid() {
		return !!this.type();
	}
}

export class DocumentList extends Component {

	state = {
		docs: [],
		previewDoc: null
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if ((!prevProps.user && this.props.user) || (this.props.user && prevProps.user.clientId !== this.props.user.clientId)) {
			this.update();
		}
	}

	async update() {
		const docs = await DocumentService.GetClientDocuments(this.props.user.clientId);
		console.log('DocumentList docs:', docs);
		if(isArray(docs)) {
			docs.sort((a, b) => {
				const d1 = moment(a.modifiedDate);
				const d2 = moment(b.modifiedDate);
				if(d1 < d2)return 1;
				if(d1 > d2)return -1;
				return 0;
			})
		}
		this.setState({docs: docs});
	}

	previewDoc = (doc) => {
		this.setState({previewDoc: doc})
	}


	/*
	 {
    "clientDocumentId": 89,
    "clientId": 1698381,
    "categoryCode": "prescriptions",
    "fileName": "prescription-medical_324598_1709928647.pdf",
    "storageProviderCode": "S3",
    "displayName": "Medical Prescription (Mar 8, 2024)",
    "createdDate": "2024-03-08T20:10:48.1501573",
    "modifiedDate": "2024-03-08T20:10:48.1498443",
    "modifiedBy": 712,
    "isDirty": true
  }
	 */


	render() {

		const docs = [];
		const cats = {};
		for (let i = 0; i < this.state.docs.length; i++) {
			const doc = this.state.docs[i];
			const cat = doc.categoryCode;
			if (!cats[cat]) {
				cats[cat] = [];
				docs.push(
					<UITreeItem title={cat.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase()}>
						{cats[cat]}
					</UITreeItem>)
			}
			cats[cat].push(<DocumentListItem doc={doc} onPreview={this.previewDoc}/>);

		}

		return (<div className={'document-list'}>
			{docs}
			{this.state.previewDoc ? <SideModal
				isOpen={!!this.state.previewDoc}
                onRequestClose={() => this.setState({previewDoc: null})}
			>
				<DocumentPreview doc={this.state.previewDoc}/>
			</SideModal> : null}
		</div>)
	}
}


/*
 {
"clientDocumentId": 89,
"clientId": 1698381,
"categoryCode": "prescriptions",
"fileName": "prescription-medical_324598_1709928647.pdf",
"storageProviderCode": "S3",
"displayName": "Medical Prescription (Mar 8, 2024)",
"createdDate": "2024-03-08T20:10:48.1501573",
"modifiedDate": "2024-03-08T20:10:48.1498443",
"modifiedBy": 712,
"isDirty": true
}
 */


export class DocumentListItem extends Component {
	state = {
		showPreview: false
	}
	onClick = async () => {
		if (this.props.onPreview) {
			this.props.onPreview(this.props.doc);
		}
	}

	render() {
		return (
			<div className={'document-list-item'} onClick={this.onClick}><Icon name="file" />{this.props.doc.displayName}
			</div>
		)
	}
}

export class DocumentPreview extends Component {
	state = {
		file: null
	}

	get fileType() {
		return this.state.file ? this.state.file.type : null;
	}

	async componentDidMount() {
		const doc = this.props.doc;
		const clientId = doc.clientId;
		const docId = doc.clientDocumentId;
		const file = await DocumentService.GetClientDocument(clientId, docId);
		this.setState({file});
	}

	shouldComponentUpdate(nextProps, nextState, nextContext) {
		return this.state.file !== nextState.file;
	}

	render() {
		let view = <LoadingSpinner/>;
		if (this.state.file) {
			const url = URL.createObjectURL(this.state.file);
			view = <iframe src={url}/>
		}

		return (<div className={'document-preview'}>{view}</div>)
	}
}



// WEBPACK FOOTER //
// ./src/views/Clients/UserDetails.js